module.exports = __webpack_public_path__ + "static/img/4.8e04bfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/4.png
// module id = iRvI
// module chunks = 1